import { Injectable, Inject, forwardRef } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IApiRequest, IApiresponse } from 'src/app/_models';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ITwoStepApprovalSaveRequest, ITwoStepApprovalSaveResponse } from 'src/app/_models/twostepapproval/twostepapproval';
import { setHeader } from 'src/app/_helpers/setRequestHeader';
import { ClaimsHeaderService } from 'src/app/shared/claimsHeader/claims-header.service';

@Injectable({
  providedIn: 'root'
})
export class TwostepapprovalService {

  constructor(private http: HttpClient, private header: setHeader, private claimsHeaderService: ClaimsHeaderService) { }

  UpdateTwoStepApprovalForOrganisation(requestinfo: IApiRequest<ITwoStepApprovalSaveRequest>): Observable<IApiresponse<ITwoStepApprovalSaveResponse>> {
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<ITwoStepApprovalSaveResponse>>(`${environment.billingApiUrl}SetTwoStepAppForOrganisation`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }


  GetExpensesCountForApproval(): Observable<any> {
    return this.http.get<any>(
      `${environment.expenseApiUrl}GetExpensesCountForApproval`,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }
  UpdateReceiptTypeOnOffForOrganisation(requestinfo: IApiRequest<ITwoStepApprovalSaveRequest>): Observable<IApiresponse<ITwoStepApprovalSaveResponse>> {
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<ITwoStepApprovalSaveResponse>>(`${environment.billingApiUrl}UpdateReceiptTypeOnOffForOrganisation`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

  UpdatePassengerLoadOnOffForOrganisation(requestinfo: IApiRequest<ITwoStepApprovalSaveRequest>): Observable<IApiresponse<ITwoStepApprovalSaveResponse>> {
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<ITwoStepApprovalSaveResponse>>(`${environment.billingApiUrl}UpdatePassengerLoadOnOffForOrganisation`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }


  UpdateManualVatOnOffForOrganisation(requestinfo: IApiRequest<ITwoStepApprovalSaveRequest>): Observable<IApiresponse<ITwoStepApprovalSaveResponse>> {
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<ITwoStepApprovalSaveResponse>>(`${environment.billingApiUrl}UpdateManualVatOnOffForOrganisation`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

  UpdateFmEditExpenseOnOffForOrganisation(requestinfo: IApiRequest<ITwoStepApprovalSaveRequest>): Observable<IApiresponse<ITwoStepApprovalSaveResponse>> {
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<ITwoStepApprovalSaveResponse>>(`${environment.billingApiUrl}UpdateFmEditExpenseOnOffForOrganisation`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

  UpdateCostCentreAndCustomerOnOffForOrganisation(requestinfo: IApiRequest<ITwoStepApprovalSaveRequest>): Observable<IApiresponse<ITwoStepApprovalSaveResponse>> {
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<ITwoStepApprovalSaveResponse>>(`${environment.billingApiUrl}UpdateCostCentreAndCustomerOnOffForOrganisation`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

}
